<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="bookprice-history"
      :md-click-outside-to-close="clickOutside"
    >
      <md-dialog-title>
        <div class="md-layout" style="margin-bottom:20px">
          <div class="md-layout-item md-size-15">
            <div
              class="-percent"
              style="font-size:12px; color:#949496; margin-bottom: 5px;"
            >
              Product Code
            </div>
            <div style="font-size:16px;line-height: 0.8;">
              {{ selectedRow.code }}
            </div>
          </div>
          <div class="md-layout-item md-size-70">
            <div
              class="-percent"
              style="font-size:12px; color:#949496; margin-bottom: 5px;"
            >
              Product Name
            </div>
            <div style="font-size:16px;font-family:kanit;line-height: 0.8;">
              {{ selectedRow.title_th }}
            </div>
          </div>
          <div
            class="md-layout-item md-size-15"
            style="text-align:right;cursor:pointer"
            @click="closeDialog()"
          >
            <md-icon>close</md-icon>
          </div>
        </div>

        <div class="md-layout">
          <div
            class="md-layout-item md-size-100"
            style="font-family: lato; font-size: 18px; font-weight: bold;"
          >
            PRICE HISTORY
          </div>
        </div>

        <div id="table-bookprice-history">
          <!-- HEAD -->
          <div id="divHeadList">
            <div style="width: 23%" class="-text-right">Cost</div>
            <div style="width: 23%" class="-text-right" :title="bookGroup.desc">
              {{ bookGroup.code }}
            </div>
            <div style="width: 26%; padding-left: 55px;" class="-text-center">
              Effective Date
            </div>
            <div style="width: 28%" class="-text-center">
              Expire Date
            </div>
          </div>

          <!-- BODY -->
          <div id="divBodyList">
            <div
              v-show="tbBookpriceHistory.length === 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center; font-size: 14px;"
            >
              No data in table.
            </div>

            <!-- :class="
                rIndex % 2 == 1 ? 'row-bg-gray' : 'main-row-bg-gray row-bg-gray'
              " -->
            <div
              v-for="(item, rIndex) in tbBookpriceHistory"
              :key="rIndex"
              class="row-bg-gray"
            >
              <div id="mainRows">
                <!-- column Cost -->
                <div style="width: 23%" class="-text-right">
                  <div v-if="item.cost && item.cost != ''">
                    {{ showPoint(item.cost, "front") }}
                    <span style="font-size:11px">{{
                      showPoint(item.cost, "behind")
                    }}</span>
                  </div>
                  <div v-show="slcSearch == 1" class="-percent">
                    {{ formatNumber(item.cost, 2) }}
                  </div>
                </div>

                <!-- column Book Code -->
                <div style="width: 23%" class="-text-right">
                  <div
                    v-if="
                      item.selling_conv_price &&
                        item.selling_conv_price[bookGroup.code] != ''
                    "
                    style="display: inline;"
                  >
                    {{
                      showPoint(
                        item.selling_conv_price[bookGroup.code],
                        "front"
                      )
                    }}
                    <span style="font-size:11px">{{
                      showPoint(
                        item.selling_conv_price[bookGroup.code],
                        "behind"
                      )
                    }}</span>
                  </div>
                  <div v-else style="visibility: hidden;">-</div>
                  <!-- <div
                    v-if="slcSearch == 0"
                    :class="
                      classPercent(item.selling_conv_price, 2, 'bookcode')
                    "
                  >
                    {{ calPercent(item.selling_conv_price, 2, "bookcode") }}%
                  </div>
                  <div
                    v-else-if="slcSearch == 1"
                    :class="item.price.B1 < 0 ? '-bgred' : '-percent'"
                  >
                    {{ formatNumber(item.price[bookGroup.code], 2) }}
                  </div> -->
                </div>

                <!-- EFFECTIVE DATE -->
                <div
                  style="width: 26%; padding-left: 55px;"
                  class="-text-center"
                >
                  {{
                    item.effective_date === null || item.effective_date === ""
                      ? ""
                      : formatDate(item.effective_date)
                  }}
                </div>

                <!-- EXPIRE DATE -->
                <div style="width: 28%" class="-text-center">
                  {{
                    item.expire_date === null || item.expire_date === ""
                      ? ""
                      : formatDate(item.expire_date)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </md-dialog-title>

      <div class="layout-dialog" style="display: flex; margin-top: 20px;"></div>
    </md-dialog>
  </div>
</template>

<script>
import BookpriceService from "@/services/bookprice";
import PricingService from "@/services/pricing";
import GlobalService from "@/services/global_function";

export default {
  name: "bookpriceDialogHistory",

  props: {
    show: {
      type: Boolean,
      required: true
    },
    selectedRow: {
      type: Object,
      required: true
    },
    bookGroup: {
      type: Object,
      required: true
    },
    slcSearch: {
      type: Number,
      required: true
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.getHistory();
      }
    }
  },

  created() {},

  data() {
    return {
      clickOutside: false,
      tbBookpriceHistory: []
    };
  },

  mounted() {},
  computed: {},

  methods: {
    formatNumber(value, dicimal) {
      return PricingService.formatNumber(value, dicimal);
    },
    showPoint(value, pos) {
      return PricingService.showPoint(value, pos);
    },
    formatDate(date) {
      if (date !== undefined) {
        return GlobalService.formatDate(date, "DD/MM/YYYY");
      } else {
        return "";
      }
    },
    calPercent(price, pos, column, priceCusComp) {
      let priceA3 = 0;
      let percent = 0;

      if (column === "bookcode" || column === "customer") {
        let priceB = 0;
        let priceType = this.bookGroup.code;
        priceB =
          price[priceType] && price[priceType] !== "" ? price[priceType] : 0;

        priceA3 = price.A3 && price.A3 !== "" ? price.A3 : 0;
        if (parseFloat(priceB) === 0 || parseFloat(priceA3) === 0) {
          percent = 0;
        } else {
          percent =
            ((parseFloat(priceB) - parseFloat(priceA3)) / parseFloat(priceA3)) *
            100;
        }
      } else {
        let priceComp = priceCusComp && priceCusComp !== "" ? priceCusComp : 0;
        priceA3 = price.A3 && price.A3 !== "" ? price.A3 : 0;

        if (parseFloat(priceComp) === 0 || parseFloat(priceA3) === 0) {
          percent = 0;
        } else {
          percent =
            ((parseFloat(priceComp) - parseFloat(priceA3)) /
              parseFloat(priceA3)) *
            100;
        }
      }
      return PricingService.formatNumber(percent, pos);
    },
    classPercent(price, pos, column, priceCusComp) {
      let value = this.calPercent(price, pos, column, priceCusComp);
      if (parseFloat(value) >= 0) {
        return "-percent";
      } else {
        return "-bgred";
      }
    },
    getHistory() {
      BookpriceService.getBookPriceHistory({
        code: this.selectedRow.code,
        bookGroup: this.bookGroup.code
      }).then(response => {
        // console.log("response ==>", response);
        // response.sort((a, b) => (a.code > b.code ? 1 : -1));
        this.tbBookpriceHistory = response;
      });
    },
    closeDialog() {
      this.$emit("close");
    }
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.bookprice-history {
  width: 60%;
  max-width: 60% !important;
  height: 80%;
  transform: unset !important;
  top: 10% !important;
  left: 20% !important;

  .md-dialog-title.md-title {
    font-size: 18px;
    margin-bottom: 5px;
    padding: 24px 30px 0;
  }

  #table-bookprice-history {
    #divHeadList {
      width: 99%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 15px;

      div {
        // border: 1px solid pink;
        padding-left: 3px;
        padding-right: 3px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divBodyList {
      height: calc(80vmin - 200px);
      width: 100%;
      display: block;
      overflow-y: scroll;
      font-size: 13px;

      > div {
        width: 100%;
        // display: -webkit-inline-box;
        display: inline-block;
        padding-top: 6px;
        padding-bottom: 6px;

        #mainRows {
          font-weight: 400;
          color: #414141;
          font-family: lato;
          font-size: 13px;
          width: 100%;
          padding-left: 0px;
          display: flex;

          .-percent {
            color: #110af2;
            font-size: 11px;
          }

          .-bgred {
            font-size: 11px;
            color: #f44336;
          }
        }

        div {
          // border: 1px solid pink;
          padding-left: 3px;
          padding-right: 3px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            font-family: Kanit;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    .main-row-bg-gray {
      border-radius: 4px;
      background: #3f51b52e;

      &.row-bg-gray:hover {
        background: rgba(236, 236, 235, 1) !important;
      }
    }

    .row-bg-gray:hover {
      border-radius: 4px;
      background: rgba(236, 236, 235, 1) !important;
    }
  }
}
</style>
